export enum GigTimeTypes {
  FIXED = 1,
  HOURLY = 2,
}
